import { render } from "./CustomMultiSelect.vue?vue&type=template&id=b73ac6d8&ts=true"
import script from "./CustomMultiSelect.vue?vue&type=script&lang=ts"
export * from "./CustomMultiSelect.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__